import { useEffect, useState } from "react";
import { motion } from "motion/react";
import QRCode from "react-qr-code";
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";

import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Typography
} from "@mui/material";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
} from "chart.js";

import { Bar } from "react-chartjs-2";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import Swal from "sweetalert2";
import LoadingSpinner from "../../Blog/Spinner";
import apiSafibc from "../../../axios/axios";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
);

/*const preguntas = [
    "¿Sabes exactamente cuánto dinero ganas cada mes?",
    "¿Sabes en qué se va tu dinero cada mes?",
    "¿Tienes un presupuesto que realmente sigues?",
    "Si hoy dejaras de recibir ingresos, ¿cuántos meses podrías mantener tu estilo de vida?",
    "¿Ahorras antes de gastar?",
    "¿Tus deudas están bajo control?",
    "¿Tus ingresos aumentan cada año?",
    "¿Tu dinero está trabajando para ti mediante alguna inversión?",
    "Cuando quieres comprar algo, ¿piensas primero si realmente lo necesitas?",
    "Si calificas tu tranquilidad financiera del 1 al 10, ¿qué número te pondrías?"
];*/

const Graficos = () => {

    const [encuesta, setEncuesta] = useState(() => {
        return localStorage.getItem("encuestaActiva");
    });

    const [estadisticas, setEstadisticas] = useState([]);

    const [totalFinalizaron, setTotalFinalizaron] = useState(0);
    const [totalIngresaron, setTotalIngresaron] = useState(0);

    const [isLoading, setIsLoading] = useState(false)

    const [preguntas, setPreguntas] = useState([])
    const [respuestasPreguntas, setRespuestasPreguntas] = useState([])


    const obtenerPreguntasRespuestas = () => {


        const preguntasRespuestasEncuesta = async () => {
            try {
                const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;
                const listado = await apiSafibc.get('/preguntas-respuesta-encuesta', {
                    headers: {
                        'API-KEY': apiKey,
                        'Accept': '*/*',
                    }
                })

                setPreguntas(listado.data.preguntas)
                setRespuestasPreguntas(listado.data.respuestas)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener preguntas y respuestas, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setIsLoading(false)
            }
        }

        preguntasRespuestasEncuesta()
    }

    useEffect(() => {

        obtenerPreguntasRespuestas()

    }, [])

    // Simula crear encuesta
    const generarEncuesta = () => {

        //mandar a llamar api para crear la encuesta y regresar el id

        const encuestaActiva = localStorage.getItem("encuestaActiva")

        if (encuestaActiva) {
            return Swal.fire({
                icon: 'info',
                title: 'Encuesta Activa',
                text: 'Ya cuenta con una encuesta activa, tiene que finalizar la encuesta actual y luego generar una nueva!'
            })
        }

        const generar = async () => {
            setIsLoading(true)
            try {

                const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;

                const generando = await apiSafibc.post('/generar-encuesta-expo', null, {
                    headers: {
                        'API-KEY': apiKey,
                        'Accept': '*/*',
                    }
                })
                const id = generando.data
                setEncuesta(id);
                localStorage.setItem("encuestaActiva", id);

                setIsLoading(false)
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al generar encuesta, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setIsLoading(false)
            }

        }

        generar()

    };

    // Simula consultar estadísticas
    const obtenerGraficas = () => {

        const obtener = async () => {

            try {
                const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;
                const { data } = await apiSafibc.get(`/obtener-respuestas/${encuesta}`, {
                    headers: {
                        'API-KEY': apiKey,
                        'Accept': '*/*',
                    }
                })

                //FALTARIA MOSTRAR CORRECTAMENTE LOS DATOS EN LOS GRAFICOS
                setEstadisticas(data.resultado);
                /*const totalRespuestas = data.resultado.reduce(
                    (total, pregunta) =>
                        total +
                        pregunta.respuestas.reduce(
                            (subtotal, respuesta) => subtotal + respuesta.total,
                            0
                        ),
                    0
                );*/
                setTotalIngresaron(data.ingresaron)
                setTotalFinalizaron(data.finalizaron)

            } catch (error) {
                console.log(error)
            }

        }

        obtener()

        /*const datos = preguntas.map(() => ({
            datos: [
                Math.floor(Math.random() * 40),
                Math.floor(Math.random() * 40),
                Math.floor(Math.random() * 40),
                Math.floor(Math.random() * 40)
            ]
        }));

        setEstadisticas(datos);

        console.log(datos)
        setTotal(Math.floor(Math.random() * 250));*/

    };

    useEffect(() => {

        if (!encuesta) return;

        obtenerGraficas();

        const intervalo = setInterval(() => {

            obtenerGraficas();

        }, 2000);

        return () => clearInterval(intervalo);

    }, [encuesta]);

    const finalizarEncuesta = () => {
        Swal.fire({
            title: "¿Deseas finalizar la encuesta?",
            text: "Las personas ya no podrán responder.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, finalizar!"
        }).then(async (result) => {

            if (!result.isConfirmed) return

            //llamar api para poner activa en 0
            setIsLoading(true)
            try {
                const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;

                const finalizar = await apiSafibc.put(`/finalizar-encuesta-expo/${encuesta}`, null, {
                    headers: {
                        'API-KEY': apiKey,
                        'Accept': '*/*',
                    }
                })

                localStorage.removeItem("encuestaActiva");
                setEncuesta(null);
                setTotalFinalizaron(0)
                setTotalIngresaron(0)
                setEstadisticas([])
                setIsLoading(false)
                //maybe al finalizar tirar un reporte o algo asi algo extra


                Swal.fire({
                    icon: 'success',
                    title: 'Encuesta Finalizada',
                    text: finalizar.data.mensaje
                })

                //agregar motion en QR cuando se genera y en el box de las graficas
                //al finalizar graficar igual motion al salir

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al generar encuesta, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setIsLoading(false)
            }

        });
    }

    return (

        <Box
            sx={{
                bgcolor: "#eef2f6",
                minHeight: "100vh",
                py: 5
            }}
        >
            {isLoading ?
                <LoadingSpinner />
                : null}
            <Container maxWidth="xl" sx={{
                py: 5,
            }}>

                <motion.div
                    initial={{ opacity: 0, y: 25 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: .5 }}
                >

                    <Typography
                        variant="h3"
                        fontWeight="bold"
                        textAlign="center"
                        mb={4}
                    >
                        Autoevaluación de Salud Financiera
                    </Typography>

                    <Card
                        elevation={4}
                        sx={{
                            mb: 5,
                            borderRadius: 4
                        }}
                    >

                        <CardContent>

                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                flexWrap="wrap"
                                gap={4}
                            >

                                <Box>
                                    {
                                        !encuesta ? (

                                            <Button
                                                variant="contained"
                                                size="large"
                                                onClick={generarEncuesta}
                                            >
                                                Generar Encuesta
                                            </Button>


                                        ) : (
                                            <>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="large"
                                                    onClick={finalizarEncuesta}
                                                >
                                                    Finalizar encuesta
                                                </Button>
                                                <Typography mt={2}>
                                                    https://dominio.com/encuesta/{encuesta}
                                                </Typography>
                                            </>
                                        )



                                    }

                                </Box>

                                {
                                    encuesta &&
                                    <QRCode
                                        value={`http://172.16.24.46:3004/encuesta-expo/encuesta/${encuesta}`}
                                        size={180}
                                    />
                                }

                                {/*<Box textAlign="center">

                                    <Typography variant="h6">
                                        Total respuestas
                                    </Typography>

                                    <Typography
                                        variant="h2"
                                        fontWeight="bold"
                                    >
                                        {total}
                                    </Typography>

                                </Box>*/}

                                <Box textAlign="center">

                                    <Typography variant="h6">
                                        Encuestas Finalizadas
                                    </Typography>

                                    <Typography
                                        variant="h2"
                                        fontWeight="bold"
                                    >
                                        {totalFinalizaron}
                                    </Typography>

                                </Box>

                                <Box textAlign="center">

                                    <Typography variant="h6">
                                        Personas Ingresaron
                                    </Typography>

                                    <Typography
                                        variant="h2"
                                        fontWeight="bold"
                                    >
                                        {totalIngresaron}
                                    </Typography>

                                </Box>

                            </Box>

                        </CardContent>

                    </Card>

                    {
                        encuesta &&
                        <Swiper
                            navigation
                            modules={[Navigation]}
                            spaceBetween={20}
                            slidesPerView={1}
                        >

                            {
                                preguntas.map((pregunta, index) => (

                                    <SwiperSlide key={index}
                                        style={{
                                            padding: "20px"
                                        }}

                                    >

                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                        >

                                            <Card
                                                elevation={4}
                                                sx={{
                                                    borderRadius: 4
                                                }}
                                            >

                                                <CardContent>

                                                    <Typography
                                                        variant="h5"
                                                        fontWeight="bold"
                                                        textAlign="center"
                                                        mb={1}
                                                    >
                                                        Pregunta {index + 1}
                                                    </Typography>

                                                    <Typography
                                                        textAlign="center"
                                                        mb={4}
                                                    >
                                                        {pregunta.pregunta}
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            height: 450
                                                        }}
                                                    >
                                                        <Bar
                                                            data={{
                                                                labels: respuestasPreguntas.filter((rp) => rp.id_pregunta == pregunta.id_pregunta).map(r => r.respuesta)
                                                                /*[
                                                                    "Nunca",
                                                                    "A veces",
                                                                    "Casi siempre",
                                                                    "Siempre"
                                                                ]*/,
                                                                datasets: [
                                                                    {
                                                                        label: "Respuestas",
                                                                        data: [0, 1, 2, 3].map(opcion => {

                                                                            const estadisticaPregunta = estadisticas.find(
                                                                                x => x.id_pregunta === pregunta.id_pregunta
                                                                            );

                                                                            const respuesta = estadisticaPregunta?.respuestas.find(
                                                                                r => Number(r.respuesta) === opcion
                                                                            );

                                                                            return respuesta?.total || 0;
                                                                        }),
                                                                        backgroundColor: [
                                                                            "#ef5350",
                                                                            "#ffca28",
                                                                            "#42a5f5",
                                                                            "#66bb6a"
                                                                        ]
                                                                    }
                                                                ]
                                                            }}
                                                            options={{
                                                                responsive: true,
                                                                maintainAspectRatio: false,
                                                                plugins: {
                                                                    legend: {
                                                                        display: false
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </Box>

                                                </CardContent>

                                            </Card>

                                        </motion.div>

                                    </SwiperSlide>

                                ))
                            }

                        </Swiper>
                    }

                </motion.div>

            </Container>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </Box>

    );

};

export default Graficos;